export const APP_TIMEZONE = 'Europe/London';
export const TIME_FORMAT = 'HH:mm';
export const TIME_SHORT_FORMAT = 'HH';
export const TIME_LONG_FORMAT = 'HH:mm:ss';
export const TIME_WITH_DATE_FORMAT = 'HH:mm, MM-DD-YY';
export const DATE_FORMAT = 'MMM DD';
export const DATE_FORMAT_LONG = 'D MMMM YYYY';
export const DATETIME_FORMAT = `${TIME_FORMAT} ${DATE_FORMAT}`;
export const MOMENT_DATETIME = 'YYYY-MM-DD[T]HH:mm:ss';
export const MOMENT_DATE = 'YYYY-MM-DD';
export const DURATION_FORMAT = [
    'h[h] m[min] s[sec]',
    {
        usePlural: false,
        trim: 'both mid',
    },
];
